import { Injectable, Inject } from '@angular/core';
import { Lesson } from '../model/lesson.model';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TimeSlot } from '../model/time-slot.model';
import { ReservationSubItem } from '../model/reservation.model';

@Injectable({
  providedIn: 'root'
})
export class LessonService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  add(instructorId: number, lesson: Lesson): Observable<Lesson>  {
    return this.httpClient.post<Lesson>(`${this.baseUrl}/api/Lesson/AddLesson/${instructorId}`, lesson, this.httpOptions);
  }

  addTimeSlot(lessonId: number, timeSlot: TimeSlot): Observable<boolean> {
    return this.httpClient.post<boolean>(`${this.baseUrl}/api/Lesson/AddTimeSlot/${lessonId}`, timeSlot, this.httpOptions);
  }

  deleteTimeSlot(lessonId: number, timeSlotId: number): Observable<boolean> {
    return this.httpClient.post<boolean>(`${this.baseUrl}/api/Lesson/DeleteTimeSlot/${lessonId}/${timeSlotId}`, '', this.httpOptions);
  }

  addStudent(lessonId: number, student: ReservationSubItem): Observable<boolean> {
    return this.httpClient.post<boolean>(`${this.baseUrl}/api/Lesson/AddStudent/${lessonId}`, student, this.httpOptions);
  }
}
